import {SvgIcon} from '@mui/material';
import MainLinearGradient from './MainLinearGradient';

export default function HotelServiceIcon(props: { color?: string; }) {
	const {color = 'url(#paint0_linear_1074_1934)'} = props;
	return (
		<SvgIcon width="32" height="32" viewBox="0 0 32 32" fill="none">
			<path opacity="0.4"
			      d="M2.7998 29.336V8.04266C2.7998 5.36266 4.13314 4.01599 6.78647 4.01599H15.0931C17.7465 4.01599 19.0665 5.36266 19.0665 8.04266V29.336"
			      fill={color}/>
			<path
				d="M14.3334 12H7.7334C7.18673 12 6.7334 11.5467 6.7334 11C6.7334 10.4533 7.18673 10 7.7334 10H14.3334C14.8801 10 15.3334 10.4533 15.3334 11C15.3334 11.5467 14.8801 12 14.3334 12ZM14.3334 17H7.7334C7.18673 17 6.7334 16.5467 6.7334 16C6.7334 15.4533 7.18673 15 7.7334 15H14.3334C14.8801 15 15.3334 15.4533 15.3334 16C15.3334 16.5467 14.8801 17 14.3334 17ZM11.0001 30.3333C10.4534 30.3333 10.0001 29.88 10.0001 29.3333V24.3333C10.0001 23.7867 10.4534 23.3333 11.0001 23.3333C11.5467 23.3333 12.0001 23.7867 12.0001 24.3333V29.3333C12.0001 29.88 11.5467 30.3333 11.0001 30.3333Z"
				fill={color}/>
			<path
				d="M30.6668 28.3346H27.6402V24.3346C28.9068 23.9213 29.8268 22.7346 29.8268 21.3346V18.668C29.8268 16.9213 28.4002 15.4946 26.6535 15.4946C24.9068 15.4946 23.4802 16.9213 23.4802 18.668V21.3346C23.4802 22.7213 24.3868 23.8946 25.6268 24.3213V28.3346H1.3335C0.786829 28.3346 0.333496 28.788 0.333496 29.3346C0.333496 29.8813 0.786829 30.3346 1.3335 30.3346H26.5735C26.6002 30.3346 26.6135 30.348 26.6402 30.348C26.6668 30.348 26.6802 30.3346 26.7068 30.3346H30.6668C31.2135 30.3346 31.6668 29.8813 31.6668 29.3346C31.6668 28.788 31.2135 28.3346 30.6668 28.3346Z"
				fill={color}/>
			<defs>
				<linearGradient id="paint0_linear_1074_1934" x1="18.7193" y1="4.01599" x2="1.99417" y2="4.55983"
				                gradientUnits="userSpaceOnUse">
					<MainLinearGradient/>
				</linearGradient>
			</defs>
		</SvgIcon>
	);
}
